import { FC } from "react";
import { Badge, Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { PlaygroundAgentDetails } from "../types";

interface PlaygroundAgentListItemProps {
  agent: PlaygroundAgentDetails;
  isSelected: boolean;
  onSelect: (name: string) => void;
}

export const PlaygroundAgentListItem: FC<PlaygroundAgentListItemProps> = ({
  agent,
  isSelected,
  onSelect,
}) => {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onSelect(agent.name)}
      onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect(agent.name);
        }
      }}
      className={`al-p-3 al-rounded-lg al-border al-cursor-pointer al-transition-colors ${
        isSelected
          ? "al-bg-blue-50 al-border-blue-300"
          : "al-bg-white al-border-gray-200 hover:al-bg-gray-50"
      }`}
    >
      <Stack direction="row" justify="between" align="center">
        <div className="al-flex-1">
          <Typography variant="body" size="sm" weight="medium" className="al-text-gray-900">
            {agent.name}
          </Typography>
          <Typography size="xs" className="al-text-gray-600 al-mt-1">
            {agent.description}
          </Typography>
        </div>
        <Badge className="al-ml-2 !al-bg-purple-100 !al-text-purple-700">
          v{agent.version}
        </Badge>
      </Stack>
      {agent.labels.length > 0 && (
        <Stack direction="row" className="al-flex-wrap al-gap-1 al-mt-2">
          {agent.labels.map((label: string, idx: number) => (
            <Badge
              key={idx}
              className="al-text-[10px] !al-bg-cyan-100 !al-text-cyan-700 al-border al-border-cyan-200"
            >
              {label}
            </Badge>
          ))}
        </Stack>
      )}
    </div>
  );
};
